// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"702":"story","715":"list","962":"home"}[chunkId] || chunkId) + "-" + {"137":"8f1952ff70d3f8ea3634","677":"c2f878543e210e1d2dc5","702":"ff410f907449ec0d1abf","715":"0c2b8300ca098ee58c74","962":"ed1bd608ffaf5831a014","976":"75a18c3b8b362f0d8cbc"}[chunkId] + ".css";
};